export default function AboutUs() {
  return (
    <section id="about" className="relative w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[600px]">
        <div className="flex-1 bg-background-50 flex items-center px-8 md:px-16 py-16 md:py-20">
          <div className="max-w-xl">
            <h3 className="font-body text-3xl md:text-4xl font-bold text-foreground-900 leading-snug">
              Crafted Fresh,
              <br />
              Served with Joy.
            </h3>
            <div className="w-16 h-[2px] bg-accent-500 mt-6 mb-6"></div>
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed">
              Welcome to <strong className="text-foreground-800">D'CURE Gelato.</strong>&nbsp;the very first artisan gelato cafe in the heart of historic Malacca. Every scoop we serve is churned fresh daily using only premium natural ingredients sourced from around the world. No artificial flavours, no preservatives. Just pure, honest craftsmanship in every bite.
            </p>
            <p className="font-body text-base md:text-lg text-foreground-600 leading-relaxed mt-4">
              From our signature <strong className="text-foreground-800">gelato</strong> flavours 
              inspired by local and international tastes, to our buttery viennoiserie and 
              specialty beverages, everything at D'CURE is made with passion and an 
              unwavering commitment to quality.
            </p>
            <a
              href="#menu"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-8 inline-block bg-primary-500 text-background-950 font-label text-sm font-semibold tracking-[0.1em] px-8 py-3 rounded-full hover:bg-primary-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              SEE MORE
            </a>
          </div>
        </div>

        <div className="flex-1 relative min-h-[400px] lg:min-h-full">
          <img
            src="https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/c9492dea-0d85-4813-8071-07e47e51bee3_compressed_Gemini_Generated_Image_dk9cwgdk9cwgdk9c.webp"
            alt="D'CURE Gelato artisan scooping fresh gelato from display case"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}